import {
  TextField,
  LinkField,
  RichTextField,
  ImageField,
  Item,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { RenderingProps } from 'src/shared/shared.types';

export type C55BiographyDirectoryProps = RenderingProps<BiographyDirectoryFields>;

export type BiographyDirectoryFields = {
  Biographies?: BiographyItem[];
  Title?: TextField;
};

type BiographyItem = Item & {
  fields?: {
    Email?: TextField;
    Fax?: TextField;
    Phone?: TextField;
    AdditionalInfo?: RichTextField;
    Specialty?: TextField;
    DetailedBioLink?: LinkField;
    DisplayName?: TextField;
    Locations?: RichTextField;
    Name?: TextField;
    Title?: TextField;
    Image?: ImageField;
  };
};
